import {api} from './client';

type FileResponse = {
    name: string,
    url: string,
};


export const FilesApi = (client = api) => ({
    async create(form: FormData) {
        const result = await client.post<FileResponse>('api/files', form);
        return result.data;
    },

    async remove(fileUrl: string) {
        await client.delete(`files/${fileUrl}`);
    }

});

export const {
    create,
    remove,
} = FilesApi();
